import { createSlice } from '@reduxjs/toolkit';
import { ProjectState } from './projectTypes';
import { createProject, updateProject, deleteProject, fetchProjectById, fetchAllProjects,fetchProjectByEmployeeId } from './projectAction';

const initialState: ProjectState = {
  projects: [],
  projectsData:[],
  projectByEmployeeId:[],
  selectedProject: undefined,
  loading: false,
  error: undefined,
};

const projectSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Project
      .addCase(createProject.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.loading = false;
        state.projects.push(action.payload.data);
      })
      .addCase(createProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Project
      .addCase(updateProject.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateProject.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.projects.findIndex(project => project.project_id === action.payload.project_id);
        if (index !== -1) {
          state.projects[index] = action.payload;
        }
      })
      .addCase(updateProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Project
      .addCase(deleteProject.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteProject.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = state.projects.filter(project => project.project_id !== action.payload.project_id);
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Project by ID
      .addCase(fetchProjectById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProject = action.payload;
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Projects
      .addCase(fetchAllProjects.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.projectsData = action.payload.data;
      })
      .addCase(fetchAllProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch All Projects by employee Id
      .addCase(fetchProjectByEmployeeId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchProjectByEmployeeId.fulfilled, (state, action) => {
        state.loading = false;
        state.projectByEmployeeId = action.payload.data;
      })
      .addCase(fetchProjectByEmployeeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default projectSlice.reducer;
